// extracted by mini-css-extract-plugin
export default {"arrow":"Tooltip_arrow__oD4yg","tooltip":"Tooltip_tooltip__rm+A0"};